<template>
  <div class="musiclibrary spotify-playlists container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title" :class="{
                  'card-title-doom-yoga': client_name == 'DY',
                  'card-title-irish-date': client_name == 'MID',
                }">
                  {{ playlist_title }}
                </h4>
              </div>
            </div>
          </div>
          <b-card no-body id="musicLibrarySpotifyCard" class="p-3">
            <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
              <dataset v-slot="{ ds }" :ds-data="tracks" :ds-search-in="['track']" :ds-search-as="{ track: searchTestt }">
                <div class="row mb-2" :data-page-count="ds.dsPagecount">
                  <div class="col-xl-7 col-md-6">
                    <b-input-group class="" v-bind:class="{
                      'input-group-search-doomyoga': client_name == 'DY',
                      'input-group-search-mid': client_name == 'MID',
                    }">
                      <template #prepend>
                        <font-awesome-icon icon="fa-solid fa-magnifying-glass" size="lg" />
                      </template>
                      <dataset-search ds-search-placeholder="Search" v-bind:class="{
                        'form-control-doomyoga': client_name == 'DY',
                        'form-control-mid': client_name == 'MID',
                      }" /></b-input-group>
                  </div>
                  <div class="col-xl-5 col-md-6">
                    <dataset-show :ds-show-entries="5" class="showEntriesSelectContainer float-right" v-bind:class="{
                      'show-entries-doomyoga': client_name == 'DY',
                      'show-entries-mid': client_name == 'MID',
                    }" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h3 class="media-category-title" v-bind:class="{
                          'media-category-title-doom-yoga':
                            client_name == 'DY',
                          'media-category-title-irish-date':
                            client_name == 'MID',
                        }">
                          {{ title }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive table-playlists-responsive">
                      <table class="table" v-bind:class="{
                        'doomYogaTable doomYogaPlaylistTable':
                          client_name == 'DY',
                        'myIrishDateTable irishDatePlaylistTable':
                          client_name == 'MID',
                      }">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th>Title</th>
                            <th>Album</th>
                            <th>Duration</th>
                          </tr>
                        </thead>
                        <dataset-item tag="tbody">
                          <template #default="{ row, rowIndex }">
                            <tr>
                              <td scope="row">{{ rowIndex + 1 }}</td>
                              <td>
                                <!-- <img
                                  v-if="
                                    row.cover_image == null &&
                                    client_name == 'DY'
                                  "
                                  src="@/assets/images/doom-yoga/doomyoga-music.png"
                                />
                                <img
                                  v-if="
                                    row.cover_image == null &&
                                    client_name == 'MID'
                                  "
                                  src="@/assets/images/my-irish-date/spotify-icon-media.png"
                                /> -->
                                <img :src="row.track.album.images[0].url" />
                                {{ row.track.name }}
                              </td>
                              <td>{{ row.track.album.name }}</td>
                              <td>
                                {{ convertMsToHM(row.track.duration_ms) }}
                              </td>
                            </tr>
                          </template>
                          <template #noDataFound>
                            <tr>
                              <td colspan="4">
                                <p class="text-center datasetNoFoundP mb-0" v-bind:class="{
                                  noDataFoundDY: client_name == 'DY',
                                  noDataFoundMID: client_name == 'MID',
                                }">
                                  No data found
                                </p>
                              </td>
                            </tr>
                          </template>
                        </dataset-item>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="
                            d-flex
                            flex-md-row flex-column
                            justify-content-between
                            align-items-center
                          ">
                  <dataset-info class="mb-2 mb-md-0 datasetInfo" v-bind:class="{
                    datasetInfoDY: client_name == 'DY',
                    datasetInfoMID: client_name == 'MID',
                  }" />
                  <dataset-pager v-bind:class="{
                    datasetPagerDY: client_name == 'DY',
                    datasetPagerMID: client_name == 'MID',
                  }" />
                </div>
              </dataset>

              <div class="row">
                <div class="col-md-12">
                  <div class="row my-2">
                    <div class="col">
                      <h3 class="media-category-title" v-bind:class="{
                        'media-category-title-doom-yoga': client_name == 'DY',
                        'media-category-title-irish-date':
                          client_name == 'MID',
                      }">
                        Other Playlists
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row my-2">
                    <div class="col">
                      <VueSlickCarousel v-if="playlists_list.length > 0" v-bind="settings" v-bind:class="{
                        'slick-slider-doom-yoga': client_name == 'DY',
                        'slick-slider-irish-date': client_name == 'MID',
                      }">
                        <template #prevArrow>
                          <div class="custom-arrow">
                            <img src="@/assets/images/doom-yoga/arrow-left-active.png" />
                          </div>
                        </template>
                        <div v-for="item in playlists_list" :key="item.id" class="">
                          <router-link :to="
                            '/' +
                            client_name_to +
                            '/music_library/spotify_playlist/' +
                            item.id
                          " class="card-link eventLink">
                            <MediaCard class="media-card-item" v-bind:class="{
                              'media-card-item-dy': client_name == 'DY',
                              'media-card-item-mid': client_name == 'MID',
                            }" :title="item.title" :duration="item.duration" :img_src="item.cover" media_type="music"
                              music_type="spotify" :client_name="client_name" />
                          </router-link>
                        </div>
                        <template #nextArrow>
                          <div class="custom-arrow">
                            <img src="@/assets/images/doom-yoga/arrow-right-active.png" />
                          </div>
                        </template>
                      </VueSlickCarousel>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaCard from "../media_components/MediaCard.vue";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";

import { convertMsToHMS } from "@/utils/helper-functions.js";

import Spotify from "spotify-web-api-node";
var ServerMethods = require("spotify-web-api-node/src/server-methods");
Spotify._addMethods(ServerMethods);

import { getSpotifyToken, getSpotifyAccessToken } from "@/utils/spotify-functions.js"

var tracks = [];

export default {
  name: "SpotifyPlaylistTracks",
  props: ["client_name"],
  components: { MediaCard },
  data() {
    return {
      client_name_to: this.client_name == "DY" ? "doom_yoga" : "my_irish_date",
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "Previous",
        next: "Next",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },
      settings: {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
          //col-xl-2 col-lg-3 col-md-3 col-6
          {
            breakpoint: 1024.5,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
      title: "Surround to Sound and Silence",
      tracks: [],
      playlists_list: [],
      selected_category: null,

      onlineFilter: "",
      selected: 5,
      startsWith: "",
      playlist_title: null,
      playlist_url: null,
      playlist_cover_image: null,
      spotifyApi: null,
      authorizeURL: null,
      playlist_id: null,

      client_id: "",
      client_secret: "",
    };
  },
  mounted() {
    //
    this.getSpotifyToken()
    this.spotifyApi = new Spotify();
    this.spotifyApi.setAccessToken(
      localStorage.getItem("spotify_access_token")
    );

    tracks = [];
    this.tracks = [];

    this.getPlayListData(this.$route.params.id)
    this.getPlaylistsList();
  },
  computed: {},
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    getSpotifyToken, getSpotifyAccessToken,

    async getPlayListData(id) {
      await this.getSpotifyAccessToken();

      await axios
        .get("social/admin/playlists/" + id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.playlist_title = response.data.title
          this.playlist_id = response.data.playlist_id
          
          this.spotifyApi.setAccessToken(
            localStorage.getItem("spotify_access_token")
          );
          this.getTracksOfPlaylist(this.playlist_id, 0, 100);

          // this.events = response.data;
          // this.setEventData(response.data);
        });
    },
    getPlaylistsList() {
      console.log("in get playlists list ", this.client_name);
      axios
        .get("social/admin/playlists", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.playlists_list = response.data.data;
        });
    },

    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(tracks).slice(5, 5);
    //   this.tracks = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTestt(value, searchString, rowData) {
      return (
        rowData.track.name.toLowerCase().includes(searchString) ||
        rowData.track.album.name.toLowerCase().includes(searchString)
      );
    },
    fieldFilter,

    getTracksOfPlaylist(playlist_id, offset, limit) {
      let temp = this;
      console.log(temp.spotifyApi);
      console.log(this.spotifyApi);
      console.log(this);
      console.log(playlist_id);

      this.spotifyApi
        .getPlaylistTracks(playlist_id, {
          offset: offset,
          limit: limit,
        })
        .then(
          function (data) {
            console.log("The playlist contains these tracks", data.body);
            console.log(data);
            console.log(data.body)
            console.log(data.body.items)
            if (tracks.length == 0) {
              tracks = data.body.items;
              temp.tracks = tracks;
            } else {
              tracks = tracks.concat(data.body.items);
              temp.tracks = tracks;
            }
            console.log(tracks);
            if (data.body.next != null) {
              temp.getTracksOfPlaylist(
                playlist_id,
                data.body.items.length + offset,
                limit
              );
            } else {
            }
          },
          function (err) {
            console.log("Something went wrong!");
            console.log(err)
          }
        );
    },
    convertMsToHM(millieseconds) {
      return convertMsToHMS(millieseconds);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/music_library/SpotifyPlaylistTracks.vue